var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors;
  return {
    addToBankBackgroundColor: colors.contrasts.grey1111,
    addToBankBorderColor: colors.contrasts.grey100100
  };
};
export default generateComponentTheme;